import { SparklesIcon } from '@heroicons/react/24/solid';
import * as React from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface AIExtractedIndicatorProps {
  /** Whether to show the indicator */
  show: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * A sparkle icon indicator that shows when a field was extracted by AI.
 * Includes a tooltip explaining the extraction.
 */
export const AIExtractedIndicator: React.FC<AIExtractedIndicatorProps> = ({
  show,
  className = '',
}) => {
  if (!show) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <SparklesIcon
          className={`h-4 w-4 text-purple-500 ${className}`}
          aria-label="AI extracted"
        />
      </TooltipTrigger>
      <TooltipContent>
        <p>AI extracted from document</p>
      </TooltipContent>
    </Tooltip>
  );
};
